module.exports = __webpack_public_path__ + "static/media/3.8d84d07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/baliza/3.jpg
// module id = 509
// module chunks = 0